<template>
  <div class="sp-template">
    <div class="h-title">组织架构</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" class="demo-form-inline" size="small">

          <el-row>
            <el-input placeholder="输入关键字进行过滤" v-model="filterText">
            </el-input>

            <el-button size="small" type="primary" @click="addDept()" style="margin-left:100px;">新增部门</el-button>
          </el-row>

        </el-form>

      </div>
      <!-- <div class="table-button__groups">
        <div class="button-groups">
        </div>
      </div> -->

      <div style="width:700px;">

        <el-tree :data="data" node-key="id" default-expand-all :expand-on-click-node="false" :filter-node-method="filterNode" ref="tree">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }} {{data.admin ? '(管理员)' : ''}}</span>
            <span v-if="!data.man" style="float:right; width:400px;">
              <el-button type="text" size="mini" @click="() => append(node, data)">
                新增分组
              </el-button>

              <el-button type="text" size="mini" @click="() => removeGroup(node, data)">
                删除分组
              </el-button>

              <el-button type="text" size="mini" @click="() => addStaff(node, data)">
                添加成员
              </el-button>
            </span>
            <span v-else style="float:right; width:400px;">
              <el-button type="text" size="mini" @click="() => delStaff(node, data)">
                删除成员
              </el-button>
            </span>
          </span>
        </el-tree>

      </div>


      <!-- 添加成员 -->
      <el-dialog title="添加成员" :visible.sync="dialogVisible1" append-to-body width="500px" :close-on-click-modal="false">
        <el-form size="small" label-width="120px">
          <el-form-item label="所属分组">
            {{addStaffForm.parentData ? addStaffForm.parentData.label : ''}}
          </el-form-item>
          <el-form-item label="名字">
            <!-- <el-input v-model.trim.lazy="addStaffForm.name"></el-input> -->
            <el-select v-model.lazy="addStaffForm.userIds" multiple filterable clearable style="width:100%;">
              <el-option v-for="(d, i) in staffData" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否管理员">
            <el-radio v-model="addStaffForm.admin" label="true">是</el-radio>
            <el-radio v-model="addStaffForm.admin" label="false">否</el-radio>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible1=false">取 消</el-button>
          <el-button size="small" type="primary" @click="addStaffSubmit()">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 添加分组 -->
      <el-dialog title="添加分组" :visible.sync="dialogVisible2" append-to-body width="500px" :close-on-click-modal="false">
        <el-form size="small" label-width="120px">
          <el-form-item label="所属分组">
            {{addGroupForm.parentData ? addGroupForm.parentData.label : ''}}
          </el-form-item>
          <el-form-item label="名字">
            <el-input v-model.trim.lazy="addGroupForm.name"></el-input>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible2=false">取 消</el-button>
          <el-button size="small" type="primary" @click="addGroupSubmit()">确 定</el-button>
        </div>
      </el-dialog>

    </el-card>
  </div>
</template>

<script>

  let id = 1000;

  import axios from "axios";
  export default {
    data() {
      return {
        staffData: [],
        filterText: '',
        dialogVisible1: false,
        dialogVisible2: false,
        addStaffForm: {
          // name: '',
          userIds: [],
          admin: 'false',
          parentData: null
        },
        addGroupForm: {
          name: '',
          parentData: null
        },
        orgData: [],
        data: []
        // data: [{
        //   id: 1,
        //   label: '业务部',
        //   children: [{
        //     id: 4,
        //     label: '业务一组',
        //     children: [{
        //       id: 9,
        //       label: 'AA',
        //       man: true
        //     }, {
        //       id: 10,
        //       label: 'BB',
        //       man: true
        //     }]
        //   }]
        // }, {
        //   id: 2,
        //   label: '客服部',
        //   children: [{
        //     id: 5,
        //     label: '客服一组'
        //   }, {
        //     id: 6,
        //     label: '客服二组'
        //   }]
        // }]

      };
    },
    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    created() {

      let _this = this;
      setTimeout(() => {
        _this.$nextTick(() => {
          _this.loadStaff(null, _this.currentPage, _this.pageSize);

          _this.queryList()
        });

      }, 1000);

    },
    methods: {

      queryList(){
        this.$request1({
          method: 'get',
          url: `op/user-org`,
        }).then(res => {
          this.data = res.data.data;
        }).catch(error => {
          console.log(error);
        });

      },
      //加载数据
      loadStaff() {
        let form = {
          status: "1",
          currentPage: 1,
          pageSize: 10000
        }

        this.$request1({
          method: 'GET',
          url: '/staff/query',
          params: form
        }).then(res => {
          this.staffData = res.data.data;
        }).catch(error => {
          console.log(error);
        });
      },
      // 新增部门
      addDept() {
        this.$prompt("请输入部门名称：", "新增部门", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValidator(value) {
            if (value == null || value.trim() == "") {
              return "请输入部门名称";
            }
            return true;
          }
        }).then(({ value }) => {

          const newChild = { id: id++, label: value, children: [], man: false };
          this.data.push(newChild)

          this.$request1({
            method: 'post',
            // url: `${springHost}op/company-org`,
            url: `op/company-org`,
            data: {
              parentId: 0,
              name: value
            }
          }).then(res => {
            if(res.data.success){
              this.$message.success('添加成功')
              this.queryList()
            }else{
              this.$message.error(res.data.message)
            }
            
          }).catch(error => {
            console.log(error);
          });


        }).catch(() => {
          console.log("close");
        });
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },

      append(node, data) {
        this.addGroupForm = {
          name: '',
          parentData: data
        }
        this.dialogVisible2 = true
      },
      addGroupSubmit() {

        if (!this.addGroupForm.name) {
          this.$message.error('名字不能为空')
          return
        }

        this.$request1({
            method: 'post',
            // url: `${springHost}op/company-org`,
            url: `op/company-org`,
            data: {
              parentId: this.addGroupForm.parentData.id,
              name: this.addGroupForm.name
            }
          }).then(res => {
            if(res.data.success){
              this.dialogVisible2 = false
              this.$message.success('添加成功')
              this.queryList()
            }else{
              this.$message.error(res.data.message)
            }
            
          }).catch(error => {
            console.log(error);
          });

        // const newChild = { id: id++, label: this.addGroupForm.name, children: [], man: false };
        // if (!this.addGroupForm.parentData.children) {
        //   this.$set(this.addGroupForm.parentData, 'children', []);
        // }
        // this.addGroupForm.parentData.children.push(newChild);
        // this.dialogVisible2 = false

      },

      removeGroup(node, data) {

        this.$confirm(`是否删除分组【${data.label}】`, "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // const parent = node.parent;
          // const children = parent.data.children || parent.data;
          // const index = children.findIndex(d => d.id === data.id);
          // children.splice(index, 1);

          this.$request1({
            method: 'get',
            // url: `${springHost}op/del-company-org?id=${data.id}`
            url: `op/del-company-org?id=${data.id}`
          }).then(res => {
            if(res.data.success){
              this.$message.success('删除成功')
              this.queryList()
            }else{
              this.$message.error(res.data.message)
            }
          }).catch(error => {
            console.log(error);
          });

        }).catch(() => {
        });
      },

      addStaff(node, data) {
        // console.log('>>>>1111=', node);
        // console.log('>>>>22222=', data);

        this.addStaffForm = {
          userIds: [],
          admin: 'false',
          parentData: data
        }
        this.dialogVisible1 = true
      },
      addStaffSubmit() {
        if (this.addStaffForm.userIds.length==0) {
          this.$message.error('请选择成员')
          return
        }

        this.addStaffForm.orgId = this.addStaffForm.parentData.id

        this.$request1({
            method: 'post',
            // url: `${springHost}op/append-user-org`,
            url: `op/append-user-org`,
            data: this.addStaffForm
          }).then(res => {
            if(res.data.success){
              this.dialogVisible1 = false
              this.$message.success('添加成功')
              this.queryList()
            }else{
              this.$message.error(res.data.message)
            }
            
          }).catch(error => {
            console.log(error);
          });


        // const newChild = { id: id++, label: this.addStaffForm.name, children: [], man: true };
        // if (!this.addStaffForm.parentData.children) {
        //   this.$set(this.addStaffForm.parentData, 'children', []);
        // }
        // this.addStaffForm.parentData.children.push(newChild);
        // this.dialogVisible1 = false
      },
      delStaff(node, data) {
        this.$confirm(`是否删除成员【${data.label}】`, "警告", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {


          this.$request1({
            method: 'get',
            // url: `${springHost}op/remove-user-org?id=${data.id}`
            url: `op/remove-user-org?id=${data.id}`
          }).then(res => {
            if(res.data.success){
              this.$message.success('删除成功')
              this.queryList()
            }else{
              this.$message.error(res.data.message)
            }
          }).catch(error => {
            console.log(error);
          });

          // const parent = node.parent;
          // const children = parent.data.children || parent.data;
          // const index = children.findIndex(d => d.id === data.id);
          // children.splice(index, 1);

        }).catch(() => {
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .f-container {
    margin: -20px 0;
  }

  .f-container__left {
    *+* {
      margin-top: 15px;
    }
  }

  h3 {
    font-weight: normal;
  }


  .custom-tree-node {
    width: 100%;
    overflow: hidden;

    >span {
      &:first-child {
        float: left;
        width: 120px;

        &:hover {
          color: #409eff;
        }
      }

      &:last-child {
        /* float: right; */
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/user/orgPage.vue